export default __webpack_public_path__ + "images/d6fbb3fe068153d5f332e6baf1ec4efd-001-copy.svg";